import { createSlice } from '@reduxjs/toolkit';

/**
 *
 * @type IndustryStoreState
 */
const initialState = {
  industryList: { loading: false, data: null, error: null }
};

export const IndustrySlice = createSlice({
  name: 'industry',
  initialState,
  reducers: {
    fetchIndustryListRequest: (state, action) => {
      state.industryList.loading = true;
      state.industryList.error = null;
    },
    fetchIndustryListSuccess: (state, action) => {
      state.industryList.data = action.payload;
      state.industryList.loading = false;
      state.industryList.error = null;
    },
    fetchIndustryListFailure: (state, action) => {
      state.industryList.data = null;
      state.industryList.loading = false;
      state.industryList.error = action.payload;
    }
  }
});

export const {
  fetchIndustryListRequest,
  fetchIndustryListSuccess,
  fetchIndustryListFailure
} = IndustrySlice.actions;

/**
 *
 * @param {*} store
 * @returns {IndustryStoreState['industryList']}
 */
export const getIndustryListState = (store) => store.industry?.industryList;

export default IndustrySlice.reducer;
